module.exports = __webpack_public_path__ + "img/logo.bca97a12.svg";